import type { DateTime } from "litepicker/dist/types/datetime";

export const toCamelCase = (name: string, delim = "-") => {
  const pattern = new RegExp(delim + "([a-z])", "g");
  return name.replace(pattern, (match, capture) => capture.toUpperCase());
};

export function jsonParseHelper<T>(value: string): T {
  try {
    return JSON.parse(value) as T;
  } catch (err) {
    if (process.env.dev) {
      console.log(err);
    }
    return null;
  }
}

export function appendQueryString(url: string, queryString: string): string {
  if (url.indexOf("?") > 0) {
    url = url.substring(0, url.indexOf("?"));
  }
  url += `?${queryString}`;

  return url;
}

export function formatNumberWithCommas(num: number): string {
  const nf = new Intl.NumberFormat("en-US");
  return nf.format(num);
}

export function formatAddress(city: string, state: string, zip: string): string {
  let address = city;
  if (address?.length && state?.length) {
    address += `, ${state}`;
  } else if (state?.length) {
    address = state;
  }

  if (zip?.length && address?.length) {
    address += ` ${zip}`;
  } else {
    address = zip;
  }

  return address || "";
}

export function formatLitePickerDateRange(startDateTime: DateTime, endDateTime?: DateTime): string {
  if (startDateTime === null) {
    return null;
  }
  const yearStart = startDateTime.getFullYear();
  const monthStart = (1 + startDateTime.getMonth()).toString().padStart(2, "0");
  const dayStart = startDateTime.getDate().toString().padStart(2, "0");

  if (endDateTime) {
    const yearEnd = endDateTime.getFullYear();
    const monthEnd = (1 + endDateTime.getMonth()).toString().padStart(2, "0");
    const dayEnd = endDateTime.getDate().toString().padStart(2, "0");

    return `${monthStart}/${dayStart}/${yearStart} - ${monthEnd}/${dayEnd}/${yearEnd}`;
  }

  return `${monthStart}/${dayStart}/${yearStart}`;
}
